import React from 'react';
import {NavigationProp, useNavigation} from '@react-navigation/native';

import {AppRoute} from '../../../models/AppRoute';
import {OffersItemWithMflId} from '../../../transport/types';
import TileLarge from '../../TileLarge';

function ExclusiveOffersTileLarge(props: OffersItemWithMflId) {
  const navigation = useNavigation<NavigationProp<any>>();

  return (
    <TileLarge
      onPress={() => {
        if (props?.mflId) {
          navigation.navigate(AppRoute.EXCLUSIVE_OFFER_DETAIL, {
            mflId: props?.mflId,
          });
        }
      }}
      image={props.heroImage?.[0]}
      title={props.tileHeadline}
      description={props.description}
    />
  );
}

export default ExclusiveOffersTileLarge;
